export default [    
    {   name:'Journey',
        route:'/Journeys'
    },
    {   name:'JourneyDesign',
        route:'/Journeys/:journeyId/Design'
    },
    {   name:'JourneyGraphicEmailDesign',
        route:'/Journeys/:journeyId/JourneySteps/:journeyStepId/EmailDesign'
    },
    {   name:'ClientsJourney',
        route:'/Clients/:clientId/Journeys'
    }
];